/**
 * Per the AI Feature Instrumentation for KRs contract with DE/DS. Two maps live here so JSM can
 * own eligibility in one file; they must stay separate:
 *
 * - MCI_KR_VIEW_KEY_CONFIG tags `aiResult viewed` via substring match on skill/minion/plugin/
 *   agent identifiers.
 * - MCI_KR_ACTION_KEY_CONFIG tags `aiResult actioned` via exact `actionKey` match.
 *
 * Do not add action keys to MCI_KR_VIEW_KEY_CONFIG (that would tag viewed). Do not feed action
 * keys through mciKrAttributes (substring).
 */
export type MciKrConfigEntry = {
	serviceOrOps: 'service' | 'ops';
	countsTowardMciPlusKr?: boolean;
	countsTowardAiAdoptedKr?: boolean;
};

export const MCI_KR_VIEW_KEY_CONFIG: Record<string, MciKrConfigEntry> = {
	// Agent example — matched via agentExternalConfigReference
	jsm_example_agent: {
		serviceOrOps: 'ops',
		countsTowardMciPlusKr: true,
	},
	// Skill example — matches any skill/minion name containing this substring
	jsm_atlassian_work_item: {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	SurveysStratusMinion: {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	jsm_service_triage_agent: {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
};

/**
 * Exact `actionKey` (`payload.context.key`) for `aiResult actioned`. Matching is exact equality —
 * not substring — so keys that share a prefix (e.g. create-jsm-queue vs create-jsm-queue-group)
 * do not collide.
 */
export const MCI_KR_ACTION_KEY_CONFIG: Record<string, MciKrConfigEntry> = {
	// Request type
	'jsm-atlassian-project-create-jsm-request-type': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	'jsm-atlassian-project-create-jsm-request-type-with-fields': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	SuggestAndAddFieldsToRequestType: {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	'jsm-atlassian-project-update-request-type-groups': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	'jsm-atlassian-request-type-update-workflow': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	// Queue
	'jsm-atlassian-project-create-jsm-queue': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	'jsm-atlassian-project-update-jsm-queue': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	'jsm-atlassian-project-create-jsm-queue-group': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	'jsm-atlassian-project-update-jsm-queue-group': {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
};
